import { OrganizationModule } from '../enums/organization-module.enum';
import { SubscriptionPlan } from '../enums/subscription-plan.enum';

export const MODULE_REQUIRED_PLAN: Record<OrganizationModule, SubscriptionPlan> = {
  [OrganizationModule.Orders]: SubscriptionPlan.STANDARD,
  [OrganizationModule.Products]: SubscriptionPlan.STANDARD,
  [OrganizationModule.Customers]: SubscriptionPlan.STANDARD,
  [OrganizationModule.Inventory]: SubscriptionPlan.STANDARD,
  [OrganizationModule.Organization]: SubscriptionPlan.STANDARD,
  [OrganizationModule.Calendar]: SubscriptionPlan.OPTIMAL,
  [OrganizationModule.Integrations]: SubscriptionPlan.OPTIMAL,
};

export const PLAN_BADGE_COLOR: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.NONE]: 'gray',
  [SubscriptionPlan.STANDARD]: 'blue',
  [SubscriptionPlan.OPTIMAL]: 'purple',
  [SubscriptionPlan.PRO]: 'amber',
};

export const PLAN_DISPLAY_NAME: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.NONE]: $localize`:@@plan.name.none:Free`,
  [SubscriptionPlan.STANDARD]: $localize`:@@plan.name.standard:Standard`,
  [SubscriptionPlan.OPTIMAL]: $localize`:@@plan.name.optimal:Optimal`,
  [SubscriptionPlan.PRO]: $localize`:@@plan.name.pro:Pro`,
};
